import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton/index.jsx";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import LdsImage from "../../components/LdsImage/index.jsx";
import scan from "../../assets/module-2/2-4-10-scan.png";
import FigureCaption from "../../components/LdsFigureCaption/index.jsx";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_5_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section className="mb-5">
            <h1 className="blue text-uppercase b mt-5">
              2.4.10 Module Summary (Negative Scans/Positive Scans)
            </h1>
            <p className="mt-3 mb-0">Estimated time to complete: 1 minute</p>
          </section>

          <section>
            <FigureCaption
              noCollapse={true}
              className="figcaption-no-border align-items-center flex-column d-flex"
              radiusSize="small"
              textContent={
                <>
                  <p className="gray ">
                    &copy;2016. Avid Radiopharmaceuticals, Inc. All rights
                    reserved.
                  </p>
                </>
              }
            >
              <LdsImage
                src={scan}
                alt="Two brain scan images comparing Amyvid results. The left image shows a negative scan with no significant amyloid plaque buildup, while the right image shows a positive scan indicating the presence of amyloid plaques."
                style={{ maxWidth: "451px" }}
              />
            </FigureCaption>
          </section>

          <section className="row mt-2 align-items-center justify-content-center">
            <div className="col-12 col-lg-8">
              <h6 className="b">Negative Scans</h6>
              <ul className="ms-0">
                <li>
                  Are inconsistent with a diagnosis of AD at the time of image
                  acquisition
                </li>
                <li>
                  Always show white matter tracts with greater uptake than gray
                  matter, creating gray-white contrast
                </li>
                <li>
                  Typically show scalloping of activity in the frontal cortex
                </li>
              </ul>

              <h6 className="b">Positive Scans</h6>
              <ul className="ms-0">
                <li>Do not independently establish a diagnosis of AD</li>
                <li>
                  Always have at least 2 brain regions (each seen on more than
                  one slice) with reduced gray-white contrast OR a region with
                  intense gray matter activity
                </li>
                <li>
                  Often are difficult to clearly identify the white matter
                  tracts in several brain regions, particularly within the
                  frontal lobe inferiorly, the parietal lobes superiorly, and
                  sometimes the occipital cortex
                </li>
                <li>
                  May show gray matter uptake in the medial side of the parietal
                  lobe (the precuneus)
                </li>
              </ul>
            </div>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-4-9", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-2/module-2-4-11", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Module_5_1_0;
